<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Report" sub-title="Rangking Penilaian Pelatihan Klasikal Berdasar Nilai Tertinggi" @back="back">
            <common-training-header :withLocation="true"/>
        </a-page-header>

        <a-row style="margin-bottom: 20px;">
            <a-col class="text-right">
                <download-excel :data="excel" name="classical-scores-ranking.xls">
                    <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                </download-excel>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items" rowKey="hash" :pagination="false" bordered>
                    <a-table-column :width="50" key="number" title="No" className="align-center text-small text-left">
                        <h3 slot-scope="t,r,i" class="text-center">
                            {{ i + 1 }}
                        </h3>
                    </a-table-column>

                    <a-table-column :width="100" key="photo" title="Foto" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <div style="text-align: center">
                                <img :src="record.photo" v-if="record.photo != null" height="50" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="attendant" title="Nama" className="align-center text-small">
                        <template slot-scope="record">'
                            <h3>
                                <a-icon type="user" /> <strong>{{ record.name }}</strong> <br>
                                <a-icon type="mail" /> {{ record.email }}
                            </h3>
                        </template>
                    </a-table-column>

                    <a-table-column :width="350" key="position" title="Posisi / Asal" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <h3>{{ record.position }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column :width="400" key="class_name" title="Kelas" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <h3>{{ record.members[0].training_class.name }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column-group>
                        <span slot="title">Nilai</span>

                        <a-table-column :width="100" key="resume_score" title="Resume" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <h3><strong>{{ parseFloat(record.score_data.avg_resume).toFixed(2) }}</strong></h3>
                            </template>
                        </a-table-column>

                        <a-table-column :width="100" key="exam_score" title="Ujian" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <h3><strong>{{ parseFloat(record.score_data.avg_exam).toFixed(2) }}</strong></h3>
                            </template>
                        </a-table-column>

                        <a-table-column :width="100" key="total_score" title="Total" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <h3><strong>{{ parseFloat(record.score_data.total_score).toFixed(2) }}</strong></h3>
                            </template>
                        </a-table-column>
                    </a-table-column-group>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    computed: {
        excel() {
            let excel = []

            if (this.loading)
                return excel

            this.items.forEach((i,n) => excel.push({
                rank: n+1,
                name: i.name,
                training: i.members[0].training_class.name,
                avg_resume: parseFloat(i.score_data.avg_resume).toFixed(2),
                avg_exam: parseFloat(i.score_data.avg_exam).toFixed(2),
                total_score: parseFloat(i.score_data.total_score).toFixed(2)
            }))

            return excel
        }
    },
    data() {
        return {
            loading: false,
            items: {},
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http.get(this.routeUri('api.report.classical.highest_score'))
                .then(response => {this.items = response.data})
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    },
}
</script>
